import React from "react";
import useAuth from "../../../app/components/Login/hooks/useAuth";
import { useTranslation } from "react-i18next";
import { LOGIN_PAGE } from "../../../app/routes";
import NaviLink from "./NaviLink";

interface IProps {
  onClick?: () => void;
}

const LoginNavButton: React.FC<IProps> = ({ onClick }) => {
  const { t } = useTranslation();
  const { isLoggedIn } = useAuth();

  const getTitle = () => {
    if (isLoggedIn) {
      return `${t("moje_konto")}`;
    } else {
      return `${t("zaloguj_sie")}`;
    }
  };

  return <NaviLink title={getTitle()} link={LOGIN_PAGE} onClick={onClick} />;
};

export default LoginNavButton;
